import { EmptyState } from "./emptyState";
import { DotLoader } from "react-spinners";
import { ConfigGateProps } from "./configGateType";

import * as Css from "./style"
import { useConfigGate } from "./useConfigGate";

export const ConfigGate = ({ children }: ConfigGateProps) => {
    const { isConfigured, loading } = useConfigGate()

    if (loading) {
        return <Css.ContainerLoading>
            <DotLoader
                color="#87929D"
                loading={loading}
                size={60}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </Css.ContainerLoading> 
    }

    if (!isConfigured) {
        return (
            <EmptyState />
        );
    }

    return <>{children}</>;
};
